export const DEFAULT_APPOINTMENT_DURATION_IN_MINUTES = 30;
export const PROSPECT_VIRTUAL_APPOINTMENT_DURATION_IN_MINUTES = 60;
export const PROSPECT_APPOINTMENT_DURATION_IN_MINUTES = 120;
